(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      document.addEventListener('click', (e) => {
        const drawerToggle = e.target.closest('header-drawer summary, [aria-controls="menu-drawer"], .header__icon--menu');
        if (!drawerToggle) return;
        setTimeout(() => {
          const menuDrawer = document.querySelector('menu-drawer');
          const drawerIsOpen = menuDrawer && menuDrawer.hasAttribute('open');
          const detailsOpen = document.querySelector('header-drawer details[open]');
          if (drawerIsOpen || detailsOpen) {
            this.header.classList.remove('shopify-section-header-hidden');
            this.header.classList.add('shopify-section-header-sticky', 'drawer-open');
            const wrapper = document.querySelector('.header-wrapper');
            if (wrapper) {
              wrapper.style.background = '#000000';
              wrapper.style.backgroundImage = 'none';
            }
          } else {
            this.header.classList.remove('drawer-open');
          }
        }, 30);
      });

      this.createObserver();

      const drawerDetails = document.querySelector('header-drawer details');
      if (drawerDetails) {
        new MutationObserver(() => {
          const isOpen = drawerDetails.hasAttribute('open');
          if (isOpen) {
            this.header.classList.add('drawer-open');
            this.header.classList.remove('shopify-section-header-hidden');
            this.header.style.transform = 'none';
            this.header.style.position = 'fixed';
            this.header.style.top = '0';
            this.header.style.left = '0';
            this.header.style.right = '0';
            this.header.style.zIndex = '1000';
            const wrapper = document.querySelector('.header-wrapper');
            if (wrapper) {
              wrapper.style.background = '#000000';
              wrapper.style.backgroundImage = 'none';
            }
          } else {
            this.header.classList.remove('drawer-open');
            this.header.style.transform = '';
            this.header.style.position = '';
            this.header.style.top = '';
            this.header.style.left = '';
            this.header.style.right = '';
            this.header.style.zIndex = '';
          }
        }).observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const menuDrawer = document.querySelector('menu-drawer');
      const drawerIsOpen = menuDrawer && menuDrawer.hasAttribute('open');
      const detailsOpen = document.querySelector('header-drawer details[open]');
      if (drawerIsOpen || detailsOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      const menuDrawer = document.querySelector('menu-drawer');
      if (menuDrawer && menuDrawer.hasAttribute('open')) return;
      if (document.querySelector('header-drawer details[open]')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
